module.exports = __webpack_public_path__ + "static/media/desktop_GMA-S2100_Desktop_02.84117337.jpg";